import React from 'react';
import { Chart } from 'react-google-charts';

class Texting extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            sending: false,
            loading: false,
            file: false,
            send: {
                file: false
            },
            queuedSortBy: 'dateCreated',
            queuedSortDirection: -1,
            queuedFilterBy: {},
            scheduledSortBy: 'dateCreated',
            scheduledSortDirection: -1,
            scheduledFilterBy: {}

        };
        this.urlParams = new URLSearchParams(window.location.search);
    }

    cancel = () => {
        this.setState({ sending: false, deleting: false, loading: false })
    }

    sending = () => {
        this.setState({
            sending: true, sendError: false, file: false,
            send: {
                file: false
            }
        })
    }

    editSendField = (field) => (e) => {
        var send = Object.assign({}, this.state.send)
        send[field] = e.currentTarget.value
        this.setState({ send: send, sendError: false })
    }

    confirmSend = () => {
        if (!this.state.send.file || this.state.file.name.slice(-3) != 'csv') {
            this.setState({ sendError: "Please upload a csv file for texting." })
        } else {
            this.setState({ loading: true });
            this.props.ws.send(JSON.stringify({ route: 'sendText', texts: this.state.send }))
        }
    }

    deleteText = (text) => (e) => {
        e.stopPropagation()
        this.setState({ deleting: text })
    }
    confirmDeleteText = (e) => {
        this.setState({ loading: true })
        this.props.ws.send(JSON.stringify({ route: 'deleteText', sid: this.state.deleting.ID }))
    }


    queuedSort = (field) => (e) => {
        var dir = 1
        if (field == this.state.queuedSortBy) {
            dir = this.state.queuedSortDirection * -1
        }
        this.setState({ queuedSortBy: field, queuedSortDirection: dir })
    }

    scheduledSort = (field) => (e) => {
        var dir = 1
        if (field == this.state.scheduledSortBy) {
            dir = this.state.scheduledSortDirection * -1
        }
        this.setState({ scheduledSortBy: field, scheduledSortDirection: dir })
    }

    queuedFilter = (field) => (e) => {
        var queuedFilterBy = Object.assign({}, this.state.queuedFilterBy)
        if (e.target.value.length > 0) {
            queuedFilterBy[field] = e.target.value
        } else {
            delete queuedFilterBy[field]
        }
        this.setState({ queuedFilterBy: queuedFilterBy })
    }

    scheduledFilter = (field) => (e) => {
        var scheduledFilterBy = Object.assign({}, this.state.scheduledFilterBy)
        if (e.target.value.length > 0) {
            scheduledFilterBy[field] = e.target.value
        } else {
            delete scheduledFilterBy[field]
        }
        this.setState({ scheduledFilterBy: scheduledFilterBy })
    }


    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (prop == 'DateTimeToSendEST') {
                    if (new Date(object.DateTimeToSendEST).toLocaleString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                        return false
                    }
                } else {
                    if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                        return false
                    }
                }
            }
            return true
        })
    }

    setFileName = (e) => {
        if (e.target.files.length > 0) {
            this.setState({ file: e.target.files[0] })
        } else {
            this.setState({ file: false })
        }
        this.fileReader = new FileReader()
        this.fileReader.onload = (event) => {
            var send = Object.assign({}, this.state.send)
            send.file = this.fileReader.result.split(';base64,').pop()
            this.setState({ send: send, sendError: false })
        }
        this.fileReader.readAsDataURL(e.target.files[0])
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.cancel();
        }
    }

    convertSec(sec) {
        var d, h, m, s;
        s = Math.floor(sec);
        m = Math.floor(s / 60);
        s = s % 60;
        h = Math.floor(m / 60);
        m = m % 60;
        d = Math.floor(h / 24);
        h = h % 24;

        var statusTime = ''

        d > 0 ? statusTime += d + ' days, ' : statusTime += ''
        h < 1 ? statusTime += '' : h > 0 && h < 10 ? statusTime += '0' + h + ':' : statusTime += h + ':'
        m < 1 ? statusTime += '00:' : m < 10 ? statusTime += '0' + m + ':' : statusTime += m + ':'
        s < 1 ? statusTime += '00' : s < 10 ? statusTime += '0' + s : statusTime += s

        return statusTime;
    };

    render() {
        if (this.props.active) {
            var sendPane = ""
            if (this.state.sending) {
                sendPane = (
                    <div className="blackout">
                        <div className="pop">
                            <div className="viewCloser" onClick={this.cancel}></div>

                            <div>Upload a .csv file to schedule texts to be sent.</div>

                            <input style={{ width: '0.1px', height: '0.1px', opacity: '0', overflow: 'hidden', position: 'absolute', zIndex: '-1' }} type="file" id="wav" onChange={this.setFileName} />

                            {this.state.file ?
                                <div >
                                    <label style={{ display: 'inline-block', border: '1px solid #379', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }} className="button" htmlFor="wav">Browse
                                    </label>

                                    <span style={{ display: 'inline-block', border: '1px solid #379', padding: '15px 29px', fontSize: '25px', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }}>{this.state.file.name.split('\\')[this.state.file.name.split('\\').length - 1]}
                                    </span>
                                </div>

                                : <div style={{ margin: '25px' }}>
                                    <label className="button" htmlFor="wav">Browse</label>
                                </div>
                            }

                            <div className="error">{this.state.sendError}</div>
                            {this.state.send.file ? this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmSend}>Upload File</div> : ''}
                        </div>
                    </div>
                )
            }

            var deletePane = ""
            if (this.state.deleting) {
                deletePane = (
                    <div className="blackout">
                        <div className="pop">
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div>Removing Text to {this.state.deleting.FirstName + ' ' + this.state.deleting.LastName + ' (' + this.state.deleting.MobileNumber + ')'}</div>
                            <div style={{ margin: "15px" }}> Scheduled for: {new Date(this.state.deleting.DateTimeToSendEST).toLocaleString()} </div>
                            {this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDeleteFax}>Cancel Text</div>}
                        </div>
                    </div>
                )
            }

            var queuedTextList = this.props.data.Texting.queued.slice()
            var scheduledTextList = this.props.data.Texting.scheduled.slice()

            if (Object.keys(this.state.queuedFilterBy).length > 0) {
                queuedTextList = this.filterFunc(queuedTextList, this.state.queuedFilterBy)
            }

            if (Object.keys(this.state.scheduledFilterBy).length > 0) {
                scheduledTextList = this.filterFunc(scheduledTextList, this.state.scheduledFilterBy)
            }

            queuedTextList.sort((a, b) => {
                if (this.state.queuedSortBy == "DateTimeToSendEST") {
                    return ((new Date(a.DateTimeToSendEST).getTime() - new Date(b.DateTimeToSendEST).getTime()) * this.state.queuedSortDirection)
                } else {
                    if (a[this.state.queuedSortBy] > b[this.state.queuedSortBy]) {
                        return this.state.queuedSortDirection
                    } else {
                        return this.state.queuedSortDirection * -1
                    }
                }
            })

            scheduledTextList.sort((a, b) => {
                if (this.state.scheduledSortBy == "DateTimeToSendEST") {
                    return ((new Date(a.DateTimeToSendEST).getTime() - new Date(b.DateTimeToSendEST).getTime()) * this.state.scheduledSortDirection)
                } else {
                    if (a[this.state.scheduledSortBy] > b[this.state.scheduledSortBy]) {
                        return this.state.scheduledSortDirection
                    } else {
                        return this.state.scheduledSortDirection * -1
                    }
                }
            })

            var queuedTexts = []
            var scheduledTexts = []

            for (var text of queuedTextList) {
                if (queuedTextList.length < 100) {
                    queuedTexts.push(
                        <div className="dataRow" key={text.ID} >
                            <div style={{ textAlign: 'left', flex: '3 0 200px' }}>{text.FirstName}</div>
                            <div style={{ textAlign: 'left', flex: '1 0 85px' }} >{text.LastName}</div>
                            <div style={{ textAlign: 'left', flex: '2 0 135px' }} >{text.MobileNumber}</div>
                            <div style={{ textAlign: 'left', flex: '2 0 135px' }} >{text.VerbiageToSend}</div>
                            <div style={{ textAlign: 'left', flex: '1 0 100px' }}>{new Date(text.DateTimeToSendEST).toLocaleString()}</div>
                            <span className="buttonBox" style={{ flex: '0 0 28px' }}>
                                <img src={this.props.img.delete} title="Delete Text" alt="Delete Text" onClick={this.deleteText(text)} />
                            </span>
                        </div>
                    )
                }
            }

            for (var text of scheduledTextList) {
                if (scheduledTexts.length < 100) {
                    scheduledTexts.push(
                        <div className="dataRow" key={text.ID}>
                            <div style={{ textAlign: 'left', flex: '3 0 200px' }}>{text.FirstName}</div>
                            <div style={{ textAlign: 'left', flex: '1 0 85px' }} >{text.LastName}</div>
                            <div style={{ textAlign: 'left', flex: '2 0 135px' }} >{text.MobileNumber}</div>
                            <div style={{ textAlign: 'left', flex: '2 0 135px' }} >{text.VerbiageToSend}</div>
                            <div style={{ textAlign: 'left', flex: '1 0 100px' }}>{new Date(text.DateTimeToSendEST).toLocaleString()}</div>
                            <span className="buttonBox" style={{ flex: '0 0 28px' }}>
                                <img src={this.props.img.delete} title="Delete Text" alt="Delete Text" onClick={this.deleteText(text)} />
                            </span>
                        </div>
                    )
                }
            }

            return (
                <div width="100%">
                    <img src={this.props.img.plus} className="plusButton" title="Send Texts" alt="Send Texts" onClick={this.sending} />

                    <h1>Queued Texts ({this.props.data.Texting.queued.length})</h1>
                    <div className="dataHeaders">
                        <span style={{ flex: '3 0 200px', cursor: 'pointer' }} onClick={this.queuedSort('FirstName')} >First Name</span>
                        <span style={{ flex: '1 0 85px', cursor: 'pointer' }} onClick={this.queuedSort('LastName')} >Last Name</span>
                        <span style={{ flex: '2 0 135px', cursor: 'pointer' }} onClick={this.queuedSort('MobileNumber')} >Mobile Number</span>
                        <span style={{ flex: '2 0 135px', cursor: 'pointer' }} onClick={this.queuedSort('VerbiageToSend')} >Verbiage</span>
                        <span style={{ flex: '1 0 100px', cursor: 'pointer' }} onClick={this.queuedSort('DateTimeToSendEST')} >Date/Time</span>
                        <span style={{ flex: '0 0 80px' }} ></span>
                    </div>
                    <div className="dataFilters">
                        <input style={{ flex: '3 0 200px' }} type="text" onChange={this.queuedFilter('FirstName')} value={this.state.queuedFilterBy.FirstName} />
                        <input style={{ flex: '1 0 85px' }} type="text" onChange={this.queuedFilter('LastName')} value={this.state.queuedFilterBy.LastName} />
                        <input style={{ flex: '2 0 135px' }} type="text" onChange={this.queuedFilter('MobileNumber')} value={this.state.queuedFilterBy.MobileNumber} />
                        <input style={{ flex: '2 0 135px' }} type="text" onChange={this.queuedFilter('VerbiageToSend')} value={this.state.queuedFilterBy.VerbiageToSend} />
                        <input style={{ flex: '1 0 100px' }} type="text" onChange={this.queuedFilter('DateTimeToSendEST')} value={this.state.queuedFilterBy.DateTimeToSendEST} />
                        <span style={{ flex: '0 0 80px' }} ></span>
                    </div>
                    {queuedTexts.length > 0 ? queuedTexts : (<div style={{ padding: '25px' }}>No Texts are queued for sending at this time. Texts will become queued once the scheduled send time is reached.</div>)}


                    <h1>Scheduled Texts  ({this.props.data.Texting.scheduled.length})</h1>
                    <div className="dataHeaders">
                        <span style={{ flex: '3 0 200px', cursor: 'pointer' }} onClick={this.scheduledSort('FirstName')} >First Name</span>
                        <span style={{ flex: '1 0 85px', cursor: 'pointer' }} onClick={this.scheduledSort('LastName')} >Last Name</span>
                        <span style={{ flex: '2 0 135px', cursor: 'pointer' }} onClick={this.scheduledSort('MobileNumber')} >Mobile Number</span>
                        <span style={{ flex: '2 0 135px', cursor: 'pointer' }} onClick={this.scheduledSort('VerbiageToSend')} >Verbiage</span>
                        <span style={{ flex: '1 0 100px', cursor: 'pointer' }} onClick={this.scheduledSort('DateTimeToSendEST')} >Date/Time</span>
                        <span style={{ flex: '0 0 80px' }} ></span>
                    </div>
                    <div className="dataFilters">
                        <input style={{ flex: '3 0 210px' }} type="text" onChange={this.scheduledFilter('FirstName')} value={this.state.scheduledFilterBy.FirstName} />
                        <input style={{ flex: '1 0 85px' }} type="text" onChange={this.scheduledFilter('LastName')} value={this.state.scheduledFilterBy.LastName} />
                        <input style={{ flex: '2 0 135px' }} type="text" onChange={this.scheduledFilter('MobileNumber')} value={this.state.scheduledFilterBy.MobileNumber} />
                        <input style={{ flex: '2 0 135px' }} type="text" onChange={this.scheduledFilter('VerbiageToSend')} value={this.state.scheduledFilterBy.VerbiageToSend} />
                        <input style={{ flex: '1 0 100px' }} type="text" onChange={this.scheduledFilter('DateTimeToSendEST')} value={this.state.scheduledFilterBy.DateTimeToSendEST} />
                        <span style={{ flex: '0 0 80px' }} ></span>
                    </div>
                    {scheduledTexts.length > 0 ? scheduledTexts : (<div style={{ padding: '25px' }}>No Texts are scheduled at this time. Upload a .csv file to initiate the scheduling process.</div>)}
                    {sendPane}
                    {deletePane}
                </div>
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}


const icon = "menuConverse"
const roles = ["View"]
export { Texting, icon, roles }